<template>
  <div>
    <table>
      <tr>
        <td>ID:</td>
        <td>{{ account.id }}</td>
      </tr>
      <tr>
        <td>Type:</td>
        <td>{{ account.type }}</td>
      </tr>
      <tr>
          <td>API key:</td>
          <td>{{account.api_keys[0].key}}</td>
        </tr>
      <tr>
        <td>Name:</td>
        <td><input type="text" v-model="name"/></td>
      </tr>
      <tr>
        <td>Sector:</td>
        <td>
          <select type="text" v-model="sector">
            <option value="energy">Energy</option>
            <option value="materials">Materials</option>
            <option value="industrials">Industrials</option>
            <option value="consumer_discretionary">Consumer Discretionary</option>
            <option value="consumer_staples">Consumer Staples</option>
            <option value="health_care">Health Care</option>
            <option value="financials">Financials</option>
            <option value="information_technology">Information Technology</option>
            <option value="telecommunication_services">Telecommunication Services</option>
            <option value="utilities">Utilities</option>
            <option value="real_estate">Real Estate</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Employees:</td>
        <td><input type="number" min="0" v-model="employees"/></td>
      </tr>
    </table>
    <button @click="cancel()">Cancel</button>
    <button @click="save()">Save</button>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      name: this.account.name,
      sector: this.account.sector,
      employees: this.account.employees
    }
  },
  watch: {
    account () {
      this.name = this.account.name
      this.sector = this.account.sector
      this.employees = this.account.employees
    }
  },
  methods: {
    cancel () {
      this.name = this.account.name
      this.sector = this.account.sector
      this.employees = this.account.employees
    },
    save () {
      var params = {}
      if (this.name !== this.account.name) params['name'] = this.name
      if (this.sector !== this.account.sector) params['sector'] = this.sector
      if (this.employees !== this.account.employees) params['employees'] = this.employees
      this.$store.dispatch('updateAccount', {
        account: this.account, 
        params: params
      })
    }
  }
}
</script>
